<template>
	<div class="license-setting">
		<template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template>
		<div style="margin-top: 10px" v-if="current_view == 'VIEW'">
			<div style="display: flex">
				<div class="search-col" style="width: 30%">
					<input
						type="text"
						v-model="search"
						placeholder="Search by license name"
						class="searchicon"
					/>
				</div>
				<div style="display: flex; align-items: center">
					<el-button
						style="margin-left: 20px"
						icon="el-icon-circle-plus-outline"
						class="button-class-white"
						@click="toggle_actions('ADD', null)"
					>
						Add New
					</el-button>
				</div>
			</div>
			<el-row class="license-table1" style="margin-top: 10px">
				<el-col :span="24">
					<el-table
						style="
							text-transform: capitalize;
							word-break: break-word;
							width: 100%;
						"
						:data="
							computedLicenseSettingsTable
								.filter(
									(el) =>
										!selected_license.length ||
										selected_license.includes(el.name)
								)
								.filter(
									(el) =>
										!search ||
										el.name.toLowerCase().includes(search.toLowerCase())
								)
								.filter(
									(el, index) => index >= startNumber - 1 && index < endNumber
								)
						"
					>
						<el-table-column
							prop="name"
							label="License"
							style="word-break: break-word"
						>
							<template slot="header" slot-scope="scope">
								License
								<el-popover width="300" placement="right" trigger="click">
									<el-input
										v-model="searched_license"
										size="mini"
										placeholder="Search License"
									></el-input>
									<div
										style="max-height: 200px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_license">
											<el-checkbox
												v-for="(formItem, index) in uniqueLicense.filter(
													(el) =>
														!searched_license ||
														el
															.toLowerCase()
															.includes(searched_license.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div
										style="text-align: center"
										v-if="
											uniqueLicense.filter(
												(el) =>
													!searched_license ||
													el
														.toLowerCase()
														.includes(searched_license.toLowerCase())
											).length == 0
										"
									>
										No results found
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_license = [...uniqueLicense]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_license = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_license.length"
											src="../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div
									@click="
										!scope.row.archived ? toggle_actions('EDIT', scope.row) : ''
									"
									:style="
										!scope.row.archived
											? `
										color: #d26300;
										cursor: pointer;
										word-break: break-word`
											: ''
									"
									style="text-transform: capitalize; word-break: break-word"
								>
									<u>{{ scope.row.name != 0 ? scope.row.name : "-" }}</u>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="Status" width="100px" show-overflow-tooltip>
							<template slot-scope="scope">
								<el-tag
									size="small"
									style="
										border-radius: 12px;
										width: 70px;
										text-align: center;
										cursor: pointer;
									"
									:type="scope.row.archived ? 'danger' : 'success'"
									@click="
										scope.row.archived
											? toggle_actions('ACTIVATE', scope.row)
											: toggle_actions('DELETE', scope.row)
									"
									>{{ !scope.row.archived ? "Active" : "Inactive" }}
								</el-tag>
								<!-- :style="
										!scope.row.archived
											? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
											: 'border-color:#D26300; background-color:#FFF9F4; color:#D26300'
									" -->
							</template>
						</el-table-column>
						<el-table-column width="100px" show-overflow-tooltip>
							<template slot-scope="scope">
								<img
									v-if="!scope.row.archived"
									@click="toggle_actions('EDIT', scope.row)"
									width="15px"
									class="mr-5"
									src="../../../assets/icons/EditIcon.png"
									style="cursor: pointer; margin-left: 10px"
								/>
								<!-- <img
									v-if="!scope.row.archived"
									@click="toggle_actions('DELETE', scope.row)"
									style="cursor: pointer"
									width="13px"
									src="../../../assets/icons/Union.png"
								/> -->
							</template>
						</el-table-column>
						<!-- <el-table-column width="60px" show-overflow-tooltip>
							<template slot-scope="scope">
								<img
									v-if="scope.row.archived"
									@click="toggle_actions('ACTIVATE', scope.row)"
									style="cursor: pointer"
									width="16px"
									src="../../../assets/icons/undo.png"
							/></template>
						</el-table-column> -->
					</el-table>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="mt-3">
				<el-col :span="8" class="text-left">
					<div>
						<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
						{{ computedLicenseSettingsTable.length }} results
					</div>
				</el-col>
				<el-col :span="8" class="text-center">
					<el-select
						v-model="perPage"
						name="per_page"
						placeholder="select per page"
						style="width: 90px !important"
						size="mini"
					>
						<el-option label="10" :value="10"></el-option>
						<el-option label="25" :value="25"></el-option>
						<el-option label="50" :value="50"></el-option>
						<el-option label="100" :value="100"></el-option>
					</el-select>
					&nbsp;<b>per page</b>
				</el-col>
				<el-col :span="8" class="text-right">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="computedLicenseSettingsTable.length"
						:page-size="perPage"
						:current-page.sync="currentPage"
					></el-pagination>
				</el-col>
			</el-row>
		</div>
		<div v-if="current_view == 'EDIT' || current_view == 'ADD'">
			<el-row>
				<el-col :span="1">
					<img
						@click="
							current_view = 'VIEW';
							$emit('show_tab');
						"
						width="35px"
						src="../../../assets/icons/Back Arrow.png"
						style="cursor: pointer"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div
						style="margin-top: 8px"
						@click="
							current_view = 'VIEW';
							$emit('show_tab');
						"
					>
						Back
					</div>
				</el-col>
			</el-row>
			<div style="margin-top: 15px">
				<el-card shadow="none" style="border-radius: 12px">
					<el-row>
						<el-col :span="20" :offset="2">
							<div style="font-size: 20px"><b>License Setting</b></div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 15px">
						<el-col :span="2" :offset="3">
							<div style="margin-top: 10px">License Title</div>
						</el-col>
						<el-col :span="6" :offset="1">
							<el-input
								type="text"
								v-model="title"
								placeholder="Enter License Name"
								class="input-class"
								v-validate="'required'"
								name="Enter License Name"
								:minlength="1"
								:maxlength="200"
							/>
							<p>
								<span
									:v-show="errors.has(`Enter License Name`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Enter License Name`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
				</el-card>
			</div>
			<div style="margin-top: 15px">
				<el-card shadow="none" style="border-radius: 12px">
					<el-row>
						<el-col :span="20" :offset="2">
							<div style="font-size: 20px"><b>Alerts</b></div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="2" :offset="3">
							<div>Filter By</div>
						</el-col>
						<el-col :span="3" :offset="1">
							<el-radio v-model="filter_by" label="designation"
								>Designation
							</el-radio>
						</el-col>
						<el-col :span="2" :offset="0">
							<el-radio v-model="filter_by" label="user">Users </el-radio>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="2" :offset="3">
							<div style="margin-top: 10px">Renewal Alerts</div>
						</el-col>
						<el-col :span="6" :offset="1">
							<el-select
								class="select"
								v-model="designations"
								filterable
								:multiple="true"
								:clearable="true"
								placeholder="Select Designation"
								v-validate="'required'"
								name="Renewal Select Designation"
								@input="
									filter_by == 'user'
										? getUsersListByDesignation(designations, '1', null)
										: ''
								"
								:collapse-tags="true"
								ref="designations"
							>
								<el-row style="height: 30px" :gutter="5">
									<el-col :span="12"
										><div
											@click="select_all('designations')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Select All
										</div></el-col
									>
									<el-col :span="12"
										><div
											@click="clear_all('designations')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Clear All
										</div></el-col
									>
								</el-row>
								<el-option
									v-for="(item, key) in designations_list"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Renewal Select Designation`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Renewal Select Designation`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
						<el-col :span="6" :offset="1">
							<el-select
								class="select"
								v-model="user"
								filterable
								:multiple="true"
								:clearable="true"
								placeholder="Select User"
								v-if="filter_by == 'user'"
								v-validate="'required'"
								name="Select User"
								:collapse-tags="true"
							>
								<el-row style="height: 30px" :gutter="5">
									<el-col :span="12"
										><div
											@click="select_all('user')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Select All
										</div></el-col
									>
									<el-col :span="12"
										><div
											@click="clear_all('user')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Clear All
										</div></el-col
									>
								</el-row>
								<el-option
									v-for="(item, key) in users_list"
									:key="key"
									:label="item.full_name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select User`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select User`) ? "This field is required" : ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="2" :offset="3">
							<div style="margin-top: 10px">Renewal Alert</div>
						</el-col>
						<el-col :span="4" :offset="1">
							<el-select
								class="select"
								v-model="days"
								filterable
								:clearable="true"
								placeholder="Select Days"
								v-validate="'required'"
								name="Select Days"
							>
								<el-option
									v-for="(item, key) in days_list"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Days`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Days`) ? "This field is required" : ""
									}}
								</span>
							</p>
						</el-col>
						<el-col :span="3" :offset="0">
							<div style="margin-top: 10px; margin-left: 20px">
								Before expiry
							</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="2" :offset="3">
							<div style="margin-top: 10px">Expiry Alerts</div>
						</el-col>
						<el-col :span="6" :offset="1">
							<el-select
								class="select"
								v-model="expiry_designations"
								filterable
								:multiple="true"
								:clearable="true"
								placeholder="Select Designation"
								v-validate="'required'"
								name="Select Designation"
								@input="
									filter_by == 'user'
										? getUsersListByDesignation(expiry_designations, '2', null)
										: ''
								"
								:collapse-tags="true"
								ref="expiry_designations"
							>
								<el-row style="height: 30px" :gutter="5">
									<el-col :span="12"
										><div
											@click="select_all('expiry_designations')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Select All
										</div></el-col
									>
									<el-col :span="12"
										><div
											@click="clear_all('expiry_designations')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Clear All
										</div></el-col
									>
								</el-row>
								<el-option
									v-for="(item, key) in designations_list"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Designation`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Designation`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
						<el-col :span="6" :offset="1">
							<el-select
								class="select"
								v-model="expiry_users"
								filterable
								:multiple="true"
								:clearable="true"
								placeholder="Select User"
								v-validate="'required'"
								name="Renewal Select User"
								v-if="filter_by == 'user'"
								:collapse-tags="true"
							>
								<el-row style="height: 30px" :gutter="5">
									<el-col :span="12"
										><div
											@click="select_all('expiry_users')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Select All
										</div></el-col
									>
									<el-col :span="12"
										><div
											@click="clear_all('expiry_users')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Clear All
										</div></el-col
									>
								</el-row>
								<el-option
									v-for="(item, key) in expiry_users_list"
									:key="key"
									:label="item.full_name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Renewal Select User`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Renewal Select User`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
				</el-card>
			</div>
			<div style="margin-top: 15px">
				<el-card shadow="none" style="border-radius: 12px">
					<el-row>
						<el-col :span="20" :offset="2">
							<div style="font-size: 20px"><b>Escalation</b></div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="3" :offset="2">
							<div>Escalation Required</div>
						</el-col>
						<el-col :span="3" :offset="1">
							<el-radio v-model="escalation_required" label="yes"
								>Yes
							</el-radio>
						</el-col>
						<el-col :span="2" :offset="0">
							<el-radio v-model="escalation_required" label="no">No </el-radio>
						</el-col>
					</el-row>
					<div v-if="escalation_required == 'yes'">
						<el-row style="margin-top: 30px">
							<el-col :span="2" :offset="3">
								<div>Filter By</div>
							</el-col>
							<el-col :span="3" :offset="1">
								<el-radio v-model="filter_by_escalation" label="designation"
									>Designation
								</el-radio>
							</el-col>
							<el-col :span="2" :offset="0">
								<el-radio v-model="filter_by_escalation" label="user"
									>Users
								</el-radio>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px">
							<el-col :span="15" :offset="6">
								<el-card
									shadow="none"
									v-for="(item, idx) in escalation_list"
									:key="idx"
									style="margin-bottom: 15px"
								>
									<el-row>
										<el-col :span="23">
											<div style="font-size: 14px">
												{{ getOrdinal(idx + 1) }} Escalation - An email alert
												will be sent if the license is not renewed within
												<el-select
													class="select"
													v-model="item.select_escalation_days"
													filterable
													:clearable="true"
													placeholder="Select Days"
													style="width: 120px !important"
													v-validate="'required'"
													name="Escalation Select Days"
													@change="getEscalation_days_list(item, idx)"
												>
													<el-option
														v-for="(item, key) in item.escalation_days_list"
														:key="key"
														:label="item.name"
														:value="item.id"
													>
													</el-option>
												</el-select>
												of renewal
												<p style="position: absolute; left: calc(60% + 5px)">
													<span
														v-show="hasError(item, 1)"
														class="text-red-dark text-xs"
													>
														{{ errorMessage(item, 1) }}
													</span>
												</p>
											</div>
										</el-col>
										<el-col
											style="margin-top: -15px; margin-left: 0px"
											:span="1"
										>
											<el-tooltip
												class="item"
												effect="light"
												content="Delete Escalation?"
												placement="bottom"
											>
												<i
													v-if="escalation_list.length > 1"
													@click="toggle_escalations('DELETE', idx)"
													style="margin-left: 30px; cursor: pointer"
													class="el-icon-circle-close"
												/>
											</el-tooltip>
										</el-col>
									</el-row>
									<el-row style="margin-top: 20px">
										<el-col :span="3" style="margin-top: 10px">
											Send To
										</el-col>
										<el-col :span="9" :offset="1">
											<el-select
												class="select"
												v-model="item.escalation_designations"
												filterable
												:multiple="true"
												:clearable="true"
												placeholder="Select Designation"
												v-validate="'required'"
												name="Escalation Designation"
												@input="
													filter_by_escalation == 'user'
														? getUsersListByDesignation(
																item.escalation_designations,
																'3',
																idx
														  )
														: ''
												"
												:collapse-tags="true"
												:ref="dynamicRefName(idx)"
											>
												<el-row style="height: 30px" :gutter="5">
													<el-col :span="12"
														><div
															@click="
																select_all('escalation_designations', idx)
															"
															style="
																cursor: pointer;
																color: #d26300;
																text-align: center;
															"
														>
															Select All
														</div></el-col
													>
													<el-col :span="12"
														><div
															@click="clear_all('escalation_designations', idx)"
															style="
																cursor: pointer;
																color: #d26300;
																text-align: center;
															"
														>
															Clear All
														</div></el-col
													>
												</el-row>
												<el-option
													v-for="(item, key) in designations_list"
													:key="key"
													:label="item.name"
													:value="item.id"
												>
												</el-option>
											</el-select>
											<p>
												<span
													v-show="hasError(item, 2)"
													class="text-red-dark text-xs"
												>
													{{ errorMessage(item, 2) }}
												</span>
											</p>
										</el-col>
										<el-col :span="9" :offset="1">
											<el-select
												class="select"
												v-model="item.escalation_users"
												filterable
												:multiple="true"
												:clearable="true"
												placeholder="Select User"
												v-if="filter_by_escalation == 'user'"
												v-validate="'required'"
												name="Escalation User"
											>
												<el-row style="height: 30px" :gutter="5">
													<el-col :span="12"
														><div
															@click="select_all('escalation_users', idx)"
															style="
																cursor: pointer;
																color: #d26300;
																text-align: center;
															"
														>
															Select All
														</div></el-col
													>
													<el-col :span="12"
														><div
															@click="clear_all('escalation_users', idx)"
															style="
																cursor: pointer;
																color: #d26300;
																text-align: center;
															"
														>
															Clear All
														</div></el-col
													>
												</el-row>
												<el-option
													v-for="(itemx, keyx) in item.users_list"
													:key="keyx"
													:label="itemx.full_name"
													:value="itemx.id"
												>
												</el-option>
											</el-select>
											<p>
												<span
													v-show="hasError(item, 3)"
													class="text-red-dark text-xs"
												>
													{{ errorMessage(item, 3) }}
												</span>
											</p>
										</el-col>
									</el-row>
								</el-card>
							</el-col>
						</el-row>
						<el-row style="margin-top: 10px">
							<el-col :span="15" :offset="6">
								<el-button
									v-if="
										lastItemSelectEscalationDays.value !== null &&
										escalation_list.length <= 2 &&
										!lastItemSelectEscalationDays.isOne
									"
									class="button-class-white"
									size="mini"
									icon="el-icon-plus"
									@click="toggle_escalations('ADD', null)"
								>
									Add Escalation
								</el-button>
								<p
									v-if="
										escalation_list.length <= 2 &&
										lastItemSelectEscalationDays.isOne
									"
									style="color: red"
								>
									Note - To add more,
									{{ getOrdinal(currentEscalationIndex + 1) }} escalation alert
									should be more than 1 day
								</p>
							</el-col>
						</el-row>
					</div>
					<el-row style="margin-top: 30px">
						<el-col :span="1" :offset="18">
							<el-button
								class="button-class-white"
								style="border: none"
								@click="
									current_view = 'VIEW';
									$emit('show_tab');
								"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col style="margin-bottom: 40px" :span="1" :offset="1">
							<el-button class="button-class" @click="add_update_escalation()">
								Update
							</el-button>
						</el-col>
					</el-row>
				</el-card>
			</div>
		</div>
		<DeleteConfirmationVue
			:deleteDialog="deleteDialog"
			:confirmationObject="confirmationObject"
			@cancel="deleteDialog = false"
			@success="delete_api_toggle"
			:confirmationTitle="confirmationTitle"
			:calling_delete="calling_delete"
		/>
	</div>
</template>

<script>
import licenseManagementService from "../../../services/licenseManagementService";
import TaskSkeletonLoader from "../labourPlaninig/tasks/taskSkeletonLoader.vue";
import DeleteConfirmationVue from "./DeleteConfirmation.vue";

export default {
	components: {
		TaskSkeletonLoader,
		DeleteConfirmationVue,
	},
	data: () => ({
		isDomLoading: true,
		title: "",
		current_view: "VIEW",
		search: "",
		perPage: 10,
		currentPage: 1,
		licenseSettingsTable: [],
		searched_license: "",
		selected_license: [],
		storeObj: {},
		filter_by: "designation",
		user: [],
		users_list: [],
		expiry_users_list: [],
		designations: [],
		designations_list: [],
		days: null,
		days_list: [],
		expiry_users: [],
		expiry_designations: [],
		escalation_required: "yes",
		filter_by_escalation: "designation",
		escalation_list: [
			{
				select_escalation_days: null,
				escalation_users: [],
				escalation_designations: [],
				escalation_days_list: [],
			},
		],
		select_escalation_days: null,
		escalation_users: [],
		escalation_designations: [],
		current_action: null,
		confirmationObject: {},
		deleteDialog: false,
		confirmationTitle: "",
		calling_delete: true,
		currentEscalationIndex: null,
		filter_by: false,
		filter_by_items: [
			{ name: "Active", id: false },
			{ name: "Archived", id: true },
		],
	}),
	watch: {
		days(val) {
			this.escalation_list[0].escalation_days_list = [];
			for (let i = 1; i < val; i++) {
				let label = i + (i === 1 ? " day" : " days"); // Append 'day' or 'days' based on the value of i
				this.escalation_list[0].escalation_days_list.push({
					name: label,
					id: i,
				});
			}
		},
	},
	computed: {
		lastItemSelectEscalationDays() {
			if (this.escalation_list.length > 0) {
				const lastItem = this.escalation_list[this.escalation_list.length - 1];
				const value = lastItem.select_escalation_days;
				return {
					value: value,
					isOne: value === 1,
				};
			}
			return { value: null, isOne: false };
		},
		computedLicenseSettingsTable() {
			let arr = [...this.licenseSettingsTable];
			return arr;
		},
		uniqueLicense() {
			let arr = [...new Set(this.licenseSettingsTable.map((el) => el.name))];
			return arr;
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.computedLicenseSettingsTable.length
			);
			return end;
		},
	},
	async mounted() {
		this.isDomLoading = true;
		this.getLicensesSettingsList();
		await this.getDesignationsList();
		for (let i = 1; i <= 60; i++) {
			let label = i + (i === 1 ? " day" : " days"); // Append 'day' or 'days' based on the value of i
			this.days_list.push({
				name: label,
				id: i,
			});
		}
	},
	methods: {
		delete_api_toggle(item, calling_delete) {
			console.log(item, "item");
			let params = {
				license_name_id: item.id,
				archived: item.action == "DELETE" ? true : false,
			};
			licenseManagementService
				.archiveLicenseSetting(params)
				.then((res) => {
					console.log(res, "ressss");
					this.$notify.success({
						title: "Success",
						message: `Setting ${
							item.action == "DELETE" ? "De-Activated" : "Activated"
						} Successfully`,
						type: "Success",
					});
					this.getLicensesSettingsList();
				})
				.catch((err) => {
					this.$notify.error({
						title: "Success",
						message: `${err}`,
						type: "Success",
					});
				});
			this.deleteDialog = false;
		},
		dynamicRefName(idx) {
			return `escalation_designations_${idx}`;
		},
		select_all(type, idx) {
			switch (type) {
				case "designations":
					let designation = [];
					for (let i = 0; i < this.designations_list.length; i++) {
						designation.push(this.designations_list[i].id);
					}
					this.designations = designation;
					this.$nextTick(() => {
						this.$refs.designations.$emit("input", this.designations);
					});
					this.$forceUpdate();
					break;
				case "user":
					let users_list = [];
					for (let i = 0; i < this.users_list.length; i++) {
						users_list.push(this.users_list[i].id);
					}
					this.user = users_list;
					this.$forceUpdate();
					break;
				case "expiry_designations":
					let expiry_designation = [];
					for (let i = 0; i < this.designations_list.length; i++) {
						expiry_designation.push(this.designations_list[i].id);
					}
					this.expiry_designations = expiry_designation;
					this.$nextTick(() => {
						this.$refs.expiry_designations.$emit(
							"input",
							this.expiry_designations
						);
					});
					this.$forceUpdate();
					break;
				case "expiry_users":
					let expiry_user = [];
					for (let i = 0; i < this.users_list.length; i++) {
						expiry_user.push(this.users_list[i].id);
					}
					this.expiry_users = expiry_user;
					this.$forceUpdate();
					break;
				case "escalation_designations":
					let escalation_designation = [];
					for (let i = 0; i < this.designations_list.length; i++) {
						escalation_designation.push(this.designations_list[i].id);
					}
					this.escalation_list[idx].escalation_designations =
						escalation_designation;
					if (this.filter_by_escalation == "user")
						this.getUsersListByDesignation(
							this.escalation_list[idx].escalation_designations,
							"3",
							idx
						);
					this.$nextTick(() => {
						const refName = this.dynamicRefName(idx);
						if (
							this.$refs[refName] &&
							typeof this.$refs[refName].$emit === "function"
						) {
							this.$refs[refName].$emit("input", this.escalation_designations);
						}
					});
					this.$forceUpdate();
					break;
				case "escalation_users":
					let escalation_user = [];
					for (
						let i = 0;
						i < this.escalation_list[idx].users_list.length;
						i++
					) {
						escalation_user.push(this.escalation_list[idx].users_list[i].id);
					}
					this.escalation_list[idx].escalation_users = escalation_user;
					this.$forceUpdate();
					break;
			}
		},
		clear_all(type, idx) {
			switch (type) {
				case "designations":
					let designations = [];
					this.designations = designations;
					this.$nextTick(() => {
						this.$refs.designations.$emit("input", this.designations);
					});
					this.$forceUpdate();
					break;
				case "user":
					let user = [];
					this.user = user;
					this.$forceUpdate();
					break;
				case "expiry_designations":
					let expiry_designation = [];
					this.expiry_designations = expiry_designation;
					this.$nextTick(() => {
						this.$refs.expiry_designations.$emit(
							"input",
							this.expiry_designations
						);
					});
					this.$forceUpdate();
					break;
				case "expiry_users":
					let expiry_user = [];
					this.expiry_users = expiry_user;
					this.$forceUpdate();
					break;
				case "escalation_designations":
					let escalation_designation = [];
					this.escalation_list[idx].escalation_designations =
						escalation_designation;
					this.$nextTick(() => {
						const refName = this.dynamicRefName(idx);
						if (
							this.$refs[refName] &&
							typeof this.$refs[refName].$emit === "function"
						) {
							this.$refs[refName].$emit("input", this.escalation_designations);
						}
					});
					this.$forceUpdate();
					break;
				case "escalation_users":
					let escalation_user = [];
					this.escalation_list[idx].escalation_users = escalation_user;
					this.$forceUpdate();
					break;
			}
		},
		hasError(item, type) {
			if (type == 1) {
				return (
					this.errors.has(`Escalation Select Days`) &&
					item.select_escalation_days === null
				);
			} else if (type == 2) {
				return (
					this.errors.has(`Escalation Designation`) &&
					item.escalation_designations.length == 0
				);
			} else if (type == 3) {
				return (
					this.errors.has(`Escalation User`) &&
					item.escalation_users.length == 0
				);
			}
		},
		errorMessage(item, type) {
			if (type == 1) {
				return this.errors.first(`Escalation Select Days`)
					? "This field is required"
					: "";
			} else if (type == 2) {
				return this.errors.first(`Escalation Designation`)
					? "This field is required"
					: "";
			} else if (type == 3) {
				return this.errors.first(`Escalation User`)
					? "This field is required"
					: "";
			}
		},
		add_update_escalation() {
			this.$validator
				.validateAll()
				.then((result) => {
					if (result) {
						let escalation1_users = [];
						let escalation1_designations = [];
						let escalation1_days = 0;
						let escalation2_users = [];
						let escalation2_designations = [];
						let escalation2_days = 0;
						let escalation3_users = [];
						let escalation3_designations = [];
						let escalation3_days = 0;
						this.escalation_list.forEach((item, index) => {
							switch (index) {
								case 0:
									escalation1_users = item.escalation_users
										? item.escalation_users
										: [];
									escalation1_designations = item.escalation_designations
										? item.escalation_designations
										: [];
									escalation1_days = item.select_escalation_days;
									break;
								case 1:
									escalation2_users = item.escalation_users
										? item.escalation_users
										: [];
									escalation2_designations = item.escalation_designations
										? item.escalation_designations
										: [];
									escalation2_days = item.select_escalation_days;
									break;
								case 2:
									escalation3_users = item.escalation_users
										? item.escalation_users
										: [];
									escalation3_designations = item.escalation_designations
										? item.escalation_designations
										: [];
									escalation3_days = item.select_escalation_days;
									break;
							}
						});
						let params = {
							id: null,
							license_name: {
								name: this.title,
							},
							alert_type: this.filter_by,
							alert_users: this.user,
							alert_designations: this.designations,
							alert_days: this.days,
							expiry_users: this.expiry_users,
							expiry_designations: this.expiry_designations,
							escalation_required:
								this.escalation_required == "yes" ? true : false,
							escalation_type: this.filter_by_escalation,
							escalation1_users: escalation1_users,
							escalation1_designations: escalation1_designations,
							escalation1_days: escalation1_days,
							escalation2_users: escalation2_users,
							escalation2_designations: escalation2_designations,
							escalation2_days: escalation2_days,
							escalation3_users: escalation3_users,
							escalation3_designations: escalation3_designations,
							escalation3_days: escalation3_days,
						};
						if (Object.entries(this.storeObj.response).length != 0) {
							params.id = this.storeObj.response.id;
							params.license_name.id = this.storeObj.response.license_name.id;
						}
						licenseManagementService
							.addUpdateLicenseSettings(params)
							.then((res) => {
								console.log(res, "response");
								this.$notify.success({
									title: "Success",
									message: `License Settings ${
										Object.entries(this.storeObj.response).length != 0
											? "Edited"
											: "Added"
									} Successfully`,
									type: "Success",
								});
								this.getLicensesSettingsList();
								this.current_view = "VIEW";
								this.$emit("show_tab");
							})
							.catch((err) => {
								if (err.response) {
									this.$notify.error({
										title: "Fail",
										message: `${JSON.parse(err.response.data).msg}`,
									});
								}
							});
					} else {
						this.$notify.error({
							title: "Fail",
							message: `Enter required fields`,
						});
					}
				})
				.catch((err) => {
					console.log(err, "errerr");
					this.$notify.error({
						title: "Fail",
						message: `Enter required fields`,
					});
				});
		},
		getLicensesSettingsList() {
			this.isDomLoading = true;
			licenseManagementService.listAllLicensesNames().then((res) => {
				this.licenseSettingsTable = JSON.parse(res.data);
				this.licenseSettingsTable = [...this.licenseSettingsTable].sort(
					(a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
				);
				this.isDomLoading = false;
			});
		},
		getOrdinal(number) {
			const remainderTen = number % 10;
			const remainderHundred = number % 100;
			if (remainderTen === 1 && remainderHundred !== 11) {
				return number + "st";
			} else if (remainderTen === 2 && remainderHundred !== 12) {
				return number + "nd";
			} else if (remainderTen === 3 && remainderHundred !== 13) {
				return number + "rd";
			} else {
				return number + "th";
			}
		},
		getEscalation_days_list(item, idx) {
			if (idx <= 1) {
				this.currentEscalationIndex = null;
				this.currentEscalationIndex = idx;
				if (this.escalation_list[idx + 1]) {
					this.$set(this.escalation_list[idx + 1], "escalation_days_list", []);
					for (let i = 1; i < item.select_escalation_days; i++) {
						let label = i + (i === 1 ? " day" : " days");
						this.escalation_list[idx + 1].escalation_days_list.push({
							name: label,
							id: i,
						});
					}
					this.escalation_list[idx + 1].select_escalation_days = null;
					for (let i = 0; i < this.escalation_list.length; i++) {
						if (this.escalation_list[i].select_escalation_days === 1) {
							if (this.escalation_list[i + 1]) {
								this.escalation_list.splice(i + 1, 1);
							}
							if (this.escalation_list[i + 1]) {
								this.escalation_list.splice(i + 1, 1);
							}
						}
					}
				}
			}
		},
		toggle_escalations(action, idx) {
			switch (action) {
				case "ADD":
					let index = this.escalation_list.length;
					this.escalation_list.push({
						select_escalation_days: null,
						escalation_users: [],
						escalation_designations: [],
						escalation_days_list: [],
					});
					if (this.escalation_list[index]) {
						this.$set(this.escalation_list[index], "escalation_days_list", []);
						for (
							let i = 1;
							i < this.escalation_list[index - 1].select_escalation_days;
							i++
						) {
							let label = i + (i === 1 ? " day" : " days");
							this.escalation_list[index].escalation_days_list.push({
								name: label,
								id: i,
							});
						}
					}
					break;
				case "DELETE":
					this.escalation_list.splice(idx, 1);
					break;
				default:
					break;
			}
		},
		toggle_actions(action, item) {
			this.storeObj = {};
			this.storeObj = item;
			if (action == "DELETE") {
				this.confirmationObject = this.storeObj;
				this.confirmationObject.action = action;
				this.confirmationTitle = `Deactivate ${this.storeObj.name}

Selected license will be deactivated. Do you wish to continue?
Note - Users will not be able to add or renew this license				
Are you sure to de-activate the Setting ?`;
				this.deleteDialog = true;
			} else if (action == "ACTIVATE") {
				this.confirmationObject = this.storeObj;
				this.confirmationObject.action = action;
				this.confirmationTitle = `Activate ${this.storeObj.name}

Selected license will be activated. Do you wish to continue?
Are you sure to activate the Setting  ?`;
				this.deleteDialog = true;
			} else {
				console.log(this.storeObj,'this.storeObj')
				this.$emit("hide_tab");
				if (item != null) {
					this.getSettingDetailsByID(action, item);
				} else {
					if (!this.storeObj || !this.storeObj.response) {
						this.storeObj = this.storeObj || {};
						this.storeObj.response = {};
					}
					this.current_action = "ADD";
					this.filter_by = "designation";
					this.designations = [];
					this.user = [];
					this.days = null;
					this.expiry_designations = [];
					this.expiry_users = [];
					this.escalation_required = "yes";
					this.filter_by_escalation = "designation";
					this.title = "";
					this.escalation_list = [
						{
							select_escalation_days: null,
							escalation_users: null,
							escalation_designations: null,
						},
					];
					this.current_view = action;
					this.$forceUpdate();
				}
			}
		},
		async getSettingDetailsByID(action, item) {
			await this.getDesignationsList();
			this.current_action = null;
			licenseManagementService
				.fetchLicenseSettingByID(item.id)
				.then(async (res) => {
					this.storeObj.response = JSON.parse(res.data);
					let response = JSON.parse(res.data);
					if (Object.entries(response).length === 0) {
						this.current_action = "ADD";
						this.filter_by = "designation";
						this.designations = [];
						this.user = [];
						this.days = null;
						this.expiry_designations = [];
						this.expiry_users = [];
						this.escalation_required = "yes";
						this.filter_by_escalation = "designation";
						this.title = item.name;
						this.escalation_list = [
							{
								select_escalation_days: null,
								escalation_users: null,
								escalation_designations: null,
							},
						];
						if (!this.storeObj || !this.storeObj.response) {
							this.storeObj = this.storeObj || {};
							this.storeObj.response = {};
						}
						this.current_view = action;
						this.$forceUpdate();
					} else {
						try {
							this.current_action = "EDIT";
							this.title = response.license_name.name;
							this.filter_by = response.alert_type;
							this.days = response.alert_days;
							this.expiry_designations = response.expiry_designations;
							if (this.filter_by == "user")
								this.getUsersListByDesignation(
									this.expiry_designations,
									"2",
									null
								);
							this.escalation_required = response.escalation_required
								? "yes"
								: "no";
							this.filter_by_escalation = response.escalation_type;
							this.designations = response.alert_designations;
							if (this.filter_by == "user")
								this.getUsersListByDesignation(this.designations, "1", null);
							this.user = response.alert_users;
							this.expiry_users = response.expiry_users;
							if (response.escalation1_designations.length > 0) {
								if (!this.escalation_list[0]) {
									this.escalation_list[0] = {};
								}
								this.escalation_list[0].escalation_designations =
									response.escalation1_designations;
								this.escalation_list[0].escalation_users =
									response.escalation1_users;
								this.escalation_list[0].select_escalation_days =
									response.escalation1_days;
								if (this.filter_by_escalation == "user")
									this.getUsersListByDesignation(
										this.escalation_list[0].escalation_designations,
										"3",
										0
									);
							}
							if (response.escalation2_designations.length > 0) {
								if (!this.escalation_list[1]) {
									this.escalation_list[1] = {};
								}
								this.escalation_list[1].escalation_designations =
									response.escalation2_designations;
								this.escalation_list[1].escalation_users =
									response.escalation2_users;
								this.escalation_list[1].select_escalation_days =
									response.escalation2_days;
								if (this.filter_by_escalation == "user")
									this.getUsersListByDesignation(
										this.escalation_list[1].escalation_designations,
										"3",
										1
									);
							}
							if (response.escalation3_designations.length > 0) {
								if (!this.escalation_list[2]) {
									this.escalation_list[2] = {};
								}
								this.escalation_list[2].escalation_designations =
									response.escalation3_designations;
								this.escalation_list[2].escalation_users =
									response.escalation3_users;
								this.escalation_list[2].select_escalation_days =
									response.escalation3_days;
								if (this.filter_by_escalation == "user")
									this.getUsersListByDesignation(
										this.escalation_list[2].escalation_designations,
										"3",
										2
									);
							}
							setTimeout(() => {
								this.$forceUpdate();
								this.current_view = action;
							}, 100);
						} catch (error) {
							console.error("Error fetching designations list:", error);
						}
					}
				});
		},
		async getDesignationsList() {
			try {
				const res = await licenseManagementService.fetchAllDesignations();
				this.designations_list = JSON.parse(res.data);
				return this.designations_list;
			} catch (error) {
				console.error("Error fetching designations list:", error);
				throw error;
			}
		},
		getUsersListByDesignation(designations, type, idx) {
			if (type == "1") this.users_list = [];
			if (type == "2") this.expiry_users_list = [];
			let params = {
				designations: designations,
				store: null,
				user_groups: [],
			};
			licenseManagementService
				.fetchAllUsersByDesignations(params)
				.then((res) => {
					if (type == "1") this.users_list = JSON.parse(res.data);
					if (type == "2") this.expiry_users_list = JSON.parse(res.data);
					if (type == "3") {
						this.escalation_list[idx].users_list = [];
						setTimeout(() => {
							this.escalation_list[idx].users_list = JSON.parse(res.data);
							this.$forceUpdate();
						}, 100);
					}
				});
		},
	},
};
</script>

<style lang="scss">
.license {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.license-table1 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		width: 100% !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 59vh;
			max-height: 59vh;
		}
	}
}
.searchicon {
	padding-left: 20px;
	height: 40px;
	border-radius: 12px;
	border: none;
	width: 100%;
	background: #ffffff
		url("https://static.thenounproject.com/png/101791-200.png") no-repeat;
	background-size: 15px;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	outline: none;
	border: 1px solid rgb(209, 203, 203);
}
</style>
